// extracted by mini-css-extract-plugin
export default {"scrollbar":"_3U38m"};